import { create } from 'zustand';
import { AdvanceQuestionType } from './advanceQuestion/hooks';
import { CorporateInfoType } from './corporateInfo/hooks';
import { TransactionPurposeType } from './transactionPurpose/hooks';
import { ContactInfoType } from './contactInfo/hooks';
import { RepresentInfoType } from './representInfo/hooks';
import { DealerInfoType } from './dealerInfo/hooks';
import { RulerInfoType } from './rulerInfo//hooks';
import { InvestorCategoryInfoType } from './investorCategoryInfo/hooks';
import { ConsentInfoType } from './consentConfirm/hooks';
import { TFAuthenticationType } from './tfAuthentication/hooks';
import { InvoiceType } from './invoice/hooks';
import { BankInfoType } from './bankInfo/hooks';
import { FatcaType } from './fatca/hooks';
/*--------------
  口座開設
  --------------*/
//入力データ管理
type EstablishStore = {
  param: CorporateAccountEstablishRequestParam;
  add: (data: CorporateAccountEstablishRequestParam) => void;
  clear: () => void;
};

export const useCorporateAccountEstablishStore = create<EstablishStore>((set) => ({
  param: {} as CorporateAccountEstablishRequestParam,
  add: (data: CorporateAccountEstablishRequestParam) =>
    // 前のデータは残してセットしたい
    set((state) => ({ param: { ...state.param, ...data } })),
  clear: () => set({ param: {} as CorporateAccountEstablishRequestParam }),
}));

export type CorporateAccountEstablishRequestParam = AdvanceQuestionType &
  CorporateInfoType &
  TransactionPurposeType &
  ContactInfoType &
  RepresentInfoType &
  DealerInfoType &
  RulerInfoType &
  InvestorCategoryInfoType &
  Partial<ConsentInfoType> &
  TFAuthenticationType &
  InvoiceType &
  BankInfoType &
  FatcaType;

type UpdateStore = {
  param: CorporateAccountUpdateRequestParam;
  add: (data: CorporateAccountUpdateRequestParam) => void;
  clear: () => void;
};

export const useUpdateStore = create<UpdateStore>((set) => ({
  param: {} as CorporateAccountUpdateRequestParam,
  add: (data: CorporateAccountUpdateRequestParam) =>
    // 前のデータは残してセットしたい
    set((state) => ({ param: { ...state.param, ...data } })),
  clear: () => set({ param: {} as CorporateAccountUpdateRequestParam }),
}));

export type CorporateAccountUpdateRequestParam = CorporateInfoType &
  TransactionPurposeType &
  ContactInfoType &
  RepresentInfoType &
  DealerInfoType &
  RulerInfoType &
  InvestorCategoryInfoType &
  TFAuthenticationType;
